<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card style="margin-top:10px">
        <v-form ref="form" v-model="isValid" lazy-validation>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select
                    v-model="wybrany_rodzaj"
                    :items="rodzaje"
                    item-text="text"
                    item-value="value"
                    return-object
                    label="Rodzaj"
                    required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                    v-model="wybrany_status"
                    :items="statusy"
                    item-text="text"
                    item-value="value"
                    return-object
                    label="Status"
                    required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <DatePicker v-model="data_utworzenia" pickerLabel="Data utworzenia" :required="true"></DatePicker>
              </v-col>
              <v-col cols="12" sm="6">
                <DatePicker v-model="planowana_data_realizacji" pickerLabel="Planowana data realizacji"></DatePicker>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="zasoby"
                    label="Zasoby"
                    rows="3"
                    required
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="siec_oparcia"
                    label="Sieć Oparcia"
                    rows="3"
                    required
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="potrzeby"
                    label="Potrzeby"
                    rows="3"
                    required
                ></v-textarea>
              </v-col>

              <v-col cols="12" sm="6">
                <DatePicker v-model="data_zakonczenia_anulowania" pickerLabel="Data zakończenia/anulacji"></DatePicker>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-btn color="success" @click="handleSubmit">Zapisz</v-btn>
              </v-col>
              <v-col cols="6" class="text-right">
                <v-btn @click="closeForm" color="error">Anuluj</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card v-if="id > 0">
          <v-card-title>Cele</v-card-title>
          <v-card-text>
            <CelePlanowZdrowienia :plan_zdrowienia_id="this.id" v-if="id > 0"></CelePlanowZdrowienia>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card v-if="id > 0">
          <v-card-title>Zadania</v-card-title>
          <v-card-text>
            <ZadaniaPlanowZdrowienia :plan_zdrowienia_id="this.id" v-if="id > 0"></ZadaniaPlanowZdrowienia>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import DatePicker from "@/components/shared/DatePicker.vue";
import dayjs from "dayjs";
import {planyTerapiiService} from "@/services/planyTerapii.service";
import swal from "sweetalert";
import CelePlanowZdrowienia from "@/components/clients/CelePlanowZdrowienia.vue";
import ZadaniaPlanowZdrowienia from "@/components/clients/ZadaniaPlanowZdrowienia.vue";

export default {
  name: "PlanZdrowieniaEdit",
  components: {ZadaniaPlanowZdrowienia, CelePlanowZdrowienia, DatePicker},
  props: ["clientid","edytowany"],
  data() {
    return {
      isValid: false,
      rodzaje: [{ text: 'Nowy', value: 0 }, { text: 'Ewaluacja', value: 1 }],
      statusy: [{ text: 'Wersja robocza', value: 0 }, { text: 'Otwarty', value: 1 }, { text: 'Zrealizowany', value: 2 },{ text: 'Anulowany', value: 3 }],
      wybrany_rodzaj: null,
      wybrany_status: null,
      zasoby: '',
      siec_oparcia: '',
      potrzeby: '',
      id: 0,
      data_utworzenia: dayjs().format('YYYY-MM-DD'),
      planowana_data_realizacji: null,
      data_zakonczenia_anulowania: null
    }
  },
  mounted() {
    if(this.edytowany == null) {
      this.wybrany_rodzaj = this.rodzaje[0]
      this.wybrany_status = this.statusy[0]
    }
  },
  watch: {
    edytowany: {
      immediate: true,
      handler(val) {
        if(val != null)
        {
          this.id = val.id
          this.wybrany_rodzaj = this.rodzaje.find(x => x.value == val.rodzajPlanu)
          this.wybrany_status = this.statusy.find(x => x.value == val.status)
          this.zasoby = val.zasoby
          this.siec_oparcia = val.siecOparcia
          this.potrzeby = val.potrzeby
          this.data_utworzenia = dayjs(val.dataUtworzenia).format('YYYY-MM-DD')
          this.planowana_data_realizacji = dayjs(val.planowanaDataRealizacji).format('YYYY-MM-DD')
          this.data_zakonczenia_anulowania = dayjs(val.dataZakoczeniaAnulowania).format('YYYY-MM-DD')
        }
      }
    }
  },
  methods: {
    showError( text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    },
    closeForm() {
      this.$emit('close')
    },
    handleSubmit()
    {
      if(this.$refs.form.validate())
      {
        if(this.id == 0) {
          planyTerapiiService.createPlan({
            clientid: this.clientid,
            rodzajPlanu: this.wybrany_rodzaj.value,
            status: this.wybrany_status.value,
            zasoby: this.zasoby,
            siecOparcia: this.siec_oparcia,
            potrzeby: this.potrzeby,
            dataUtworzenia: this.data_utworzenia,
            planowanaDataRealizacji: this.planowana_data_realizacji,
            dataZakoczeniaAnulowania: this.data_zakonczenia_anulowania
          }).then((result) => {
            this.id = result.data.result.id
          }).catch((err) => {
            if (
                err.response != null &&
                err.response.data != null &&
                err.response.data.error != null
            ) {
              this.showError(false, err.response.data.error.message)
            } else {
              this.showError(false, "Błąd zapisu planu zdrowienia.");
            }
          })
        }
        else
        {
          planyTerapiiService.updatePlan({
            id: this.id,
            rodzajPlanu: this.wybrany_rodzaj.value,
            status: this.wybrany_status.value,
            zasoby: this.zasoby,
            siecOparcia: this.siec_oparcia,
            potrzeby: this.potrzeby,
            dataUtworzenia: this.data_utworzenia,
            planowanaDataRealizacji: this.planowana_data_realizacji,
            dataZakoczeniaAnulowania: this.data_zakonczenia_anulowania
          }).then(() => {
            this.$emit('close')
          }).catch((err) => {
            if (
                err.response != null &&
                err.response.data != null &&
                err.response.data.error != null
            ) {
              this.showError(false, err.response.data.error.message)
            } else {
              this.showError(false, "Błąd zapisu planu zdrowienia.");
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>